import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { ShareClass } from '../../types/share-classes.types';
import { Company } from '../index';
import { useAppQuery } from '../use-app-query.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useDefaultShareClass = (enabled?: boolean) => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.GET_DEFAULT_SHARE_CLASS);

  const { selectedCompanyId: companyId } = Company.useSelected();
  const { data: shareClass, isLoading } = useAppQuery<ShareClass>({
    queryKey: [QueryKey.GET_DEFAULT_SHARE_CLASS, companyId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'share-classes', 'default'],
      }),
    enabled: !!companyId && enabled,
  });

  return {
    invalidateQuery,
    shareClass,
    isLoading,
  };
};
